// extracted by mini-css-extract-plugin
export var embla = "Carousel1-module--embla--9ca24";
export var embla__container = "Carousel1-module--embla__container--11436";
export var embla__slide = "Carousel1-module--embla__slide--425dc";